import { useEffect } from "react";
import { appEvents, type CompanionPromptDisplay } from "@/shared/lib/events";
import type { ChatAttachedImage } from "../lib/chatAttachments";
import { useAgentChatStore } from "../store/useAgentChatStore";

export type CompanionPromptRequestSender = (
  text: string,
  images?: ChatAttachedImage[],
  display?: CompanionPromptDisplay,
) => void;

export function useCompanionPromptRequests(sendPromptRequest: CompanionPromptRequestSender) {
  useEffect(() => {
    return appEvents.subscribe("companion:request-prompt", (event) => {
      const text = event.text.trim();
      if (!text && !event.images?.length) return;
      useAgentChatStore.getState().requestDockAutoOpen("chat-injection");
      sendPromptRequest(text, event.images, event.display);
    });
  }, [sendPromptRequest]);
}
